<template>
  <div class="production_report">

    <main class="main" style="height:100%">

      <div class="topBox">
        <span>累计在本平台翻译<i class="thickening">{{number}}</i>字</span>
        <div class="block">
          <!--日期-->
          <el-date-picker v-model="dateManufacture_start" size="mini" type="date" value-format="yyyy-MM-dd"
            placeholder="开始日期">
          </el-date-picker>
          <span style="margin:0 5px;lineHeight:28px ">至</span>
          <el-date-picker v-model="dateManufacture_end" size="mini" type="date" value-format="yyyy-MM-dd"
            placeholder="结束日期">
          </el-date-picker>

          <!--下载统计-->

          <el-button size="mini" class="btn" type="info" @click="getProduction(1)">搜索报表</el-button>
          <el-button size="mini" class="btn1" @click="handleDownloadData">下载报表</el-button>
        </div>
      </div>

      <!-- 生产table -->
      <template>
        <el-table v-loading="loading" ref="projectTable" :header-cell-style="{background:'#EEF5FF',color:'#566087'}" tooltip-effect="dark" style="width:100%" :data="productionData"
          height="100%">
          <template slot="empty">
            <div id="notDate">
              <img src="../../assets/imgs/memory/no_data.png" alt />
              <p>暂无数据</p>
            </div>
          </template>

          <el-table-column align="center" label="序号" min-width="40">
            <template slot-scope="scope">
              <p>{{scope.$index + 1}}</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="名称" :show-overflow-tooltip="true" prop="name"></el-table-column>
          <el-table-column align="center" :label="labelName" :show-overflow-tooltip="true" prop="pmUser"></el-table-column>
          <el-table-column align="center" label="语言对" :show-overflow-tooltip="true" prop="langDesc"></el-table-column>
          <el-table-column align="center" label="领域" :show-overflow-tooltip="true" prop="domain"></el-table-column>
          <el-table-column align="center" label="创建时间" :show-overflow-tooltip="true" prop="createTime" min-width="123">
          </el-table-column>
          <el-table-column align="center" label="完成时间" :show-overflow-tooltip="true" prop="finishTime" min-width="123">
          </el-table-column>
          <el-table-column align="center" label="原文字数" :show-overflow-tooltip="true" prop="sourceWordNum">
          </el-table-column>
          <el-table-column align="center" label="重复字数" :show-overflow-tooltip="true" prop="wordRepeatNum">
          </el-table-column>
          <el-table-column align="center" label="新建字数" :show-overflow-tooltip="true" prop="wordNewNum">
          </el-table-column>
        </el-table>

        <div class="paging_device">
          <el-pagination class="page" background layout="total,prev, pager, next" :total="totalRows" :page-size="20"
            :pager-count="5" :current-page.sync="currentPage" prev-text="上一页" next-text="下一页"
            @current-change="handleCurrentChange"></el-pagination>
        </div>

      </template>

      <!-- 议员业绩table -->

    </main>
  </div>
</template>

<script>
// import ExportJsonExcel from 'js-export-excel';

export default {
  name: "ProductionReport",
  data() {
    return {
      standard: true,
      number: 0, // 页面左上角总字数
      productionData: [],//生产报表列表
      dateManufacture_start: "",//生产报表日期
      dateManufacture_end: "",//生产报表日期
      totalRows: 0,//总条数
      currentPage: 1,// 当前页码 生产
      tableHeight: window.innerHeight * 0.580,//计算表格高度
      loading: true,//Loding 加载图  生产报表
      projectTitleAry: [
        { label: '名称', prop: 'name' },
        { label: '项目经理', prop: 'pmUser' },
        { label: '语言对', prop: 'langDesc' },
        { label: '领域', prop: 'domain' },
        { label: '创建时间', prop: 'createTime' },
        { label: '完成时间', prop: 'finishTime' },
        { label: '原文字数', prop: 'sourceWordNum' },
        { label: '重复字数', prop: 'wordRepeatNum' },
        { label: '新建字数', prop: 'wordNewNum' }
      ],
      labelName:"项目经理"

    };
  },
  components: {},
  mounted() {
    this.dateManufacture_start = ''
    this.dateManufacture_end = ''
    this.dateAchievement_start = ''
    this.dateAchievement_end = ''
    //获取生产报表
    this.getProduction()
    // 获取总字数
    this.getWord()
  },
  created() {
    if (process.env.VUE_APP_NAME !== "hospital") {
      this.standard = true
    } else {
      this.standard = false
    }
    if (process.env.VUE_APP_NAME==="school") {
      this.labelName = "负责人"
    }

  },


  methods: {
    //获取现在时间
    getNowFormatDate() {
      let date = new Date();
      let seperator1 = "-";
      let seperator2 = ":";
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      let currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
      // + " " + date.getHours() + seperator2 + date.getMinutes()
      // + seperator2 + date.getSeconds();
      return currentdate;

    },
    // 导出的方法
    async handleDownloadData() { // 导出表格的表头设置
      let columnNames = [];
      let columnValues = [];
      let list, tHeader, filterVal, fileName, before;
      before = this.dateManufacture_start ? "" : "前";
      let dateManufacture_start = (this.dateManufacture_start && this.dateManufacture_end) ? this.dateManufacture_start + "至" : this.dateManufacture_start
      fileName = (dateManufacture_start || "") + (this.dateManufacture_end || "后") + before + "-生产报表"
      if (!this.dateManufacture_start && !this.dateManufacture_end) {
        fileName = "生产报表"
      }
      list = await this.getProduction(1, 100000)
      if (list.length < 1) {
        return
      }
      let allColumns = this.projectTitleAry;
      for (let i = 0; i < allColumns.length; i++) {
        columnNames[i] = allColumns[i].label
        columnValues[i] = allColumns[i].prop
      }
      require.ensure([], () => {
        const { export_json_to_excel } = require('vendor/Export2Excel')
        tHeader = columnNames
        filterVal = columnValues
        let data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, fileName)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    base64(s) { return window.btoa(unescape(encodeURIComponent(s))) },
    //currentPage 页面改变时会触发
    handleCurrentChange(val) {
      this.loading = true
      //获取生产列表
      this.getProduction(val)

    },
    // 获取生产列表
    getProduction(page, rows = 20) {
      sessionStorage.setItem("myCurrentPage", page); // 将页码存sessionStorage，刷新还在当前页   生产
      let that = this
      that.loading = false
      let end_time = that.getNowFormatDate()
      let startTime = that.dateManufacture_start ? `${that.dateManufacture_start} 00:00:00` : ''
      let endTime = that.dateManufacture_end ? `${that.dateManufacture_end} 23:59:59` : `${end_time} 23:59:59`
      let filter = {
        startTime,
        endTime,
        company_code: localStorage.myCompanyCode,
        platformType: this.$platformType
      }
      console.log(3333);

      if (!startTime && !endTime) {
        filter = {
          company_code: localStorage.myCompanyCode,
          platformType: this.$platformType
        }
      }
      return this.catReq1Service('/api/v1/project/query_transProject_count', {
        filter,
        page,
        rows,
        // sort: {},
      })
        .then(function (response) {
          that.loading = false;
          if (!response.success) {
            return []
          }
          that.productionData = response.result.list
          that.totalRows = response.result.totalRows || 0
          return response.result.list
        })
        .catch(function (error) {
        });
    },

    //获取平台总字数
    getWord() {
      let that = this
      this.catReq1Service('/api/v1/project/count_project_wordNum', {

      })
        .then(function (response) {
          if (!response.success) {
            return
          }
          that.number = response.result.totalWordNum
        })
        .catch(function (error) {

        });
    },



  },

};
</script>
<style lang="less" scoped>
.production_report {
  overflow: hidden;
  height: 100%;
  .retbtn {
    width: 48px;
    height: 30px;
    background: rgba(102, 102, 102, 1);
    color: #fff;
    position: absolute;
    left: 50px;
    top: 10px;
    line-height: 30px;
    font-size: 18px;
  }
  a:visited {
    color: rgba(102, 102, 102, 1);
    text-decoration: none;
  }
  header {
    width: 100%;
    height: 58px;
    line-height: 58px;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    color: rgba(34, 34, 34, 1);
    span {
      float: left;
      margin-left: 50px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
    }
    p {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
    }
  }
  main {
    // height: 100%;
    // // width: 1660px;
    // //position: relative;
    // //min-height: 100%;
    // background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 5px 16px 0px rgba(0, 0, 0, 0.1);
    // border-radius: 6px;
    // margin-top: 31px;
    // padding: 0 20px;
    h3 {
      //   text-align: left;
      height: 30px;
      padding-top: 12px;
      div {
        float: left;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        width: 92px;
        height: 30px;
        line-height: 30px;
        cursor: pointer;
      }
      .titActive {
        border-bottom: 1px solid #0288d2;
        color: #0288d2;
      }
    }
    .cell input {
      width: 54px;
    }
    #notDate {
      // 暂无数据
      margin-top: 80px;
    }
    .topBox {
      padding-top: 10px;
      padding-bottom: 50px;
      font-size: 30px;
      span {
        float: left;
        font-size: 14px;
      }
      .thickening {
        margin: 0 5px;
        font-weight: bolder;
      }
      button {
        float: right;
        width: 92px;
        height: 28px;
        border: 0px;
        background: #5256e9;
        border-radius: 4px;
        margin-right: 0;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
    }
    .block {
      float: right;
      display: flex;
      justify-content: center;
      .demonstration1 {
        width: 250px;
      }
      .block1 {
        width: 230px;
      }
      .btn {
        margin-left: 30px;
      }
      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 150px;
      }
    }

    /deep/.el-pager li {
      // 页码样式
      min-width: 30px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      background: transparent;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
    }

    /deep/.el-pagination button {
      // 页码上下页样式
      width: 68px;
      height: 30px;
      border: 1px solid rgba(187, 187, 187, 1);
      border-radius: 2px;
      line-height: 30px;
      font-size: 14px;
      background: transparent;
      color: rgba(102, 102, 102, 1);
      font-weight: 400;
    }
    /deep/.el-pagination button:hover {
      border: 1px solid rgba(128, 128, 128, 1);
    }
    /deep/.el-pagination button:active {
      background: rgba(224, 237, 252, 1);
      border: 1px solid rgba(187, 187, 187, 1);
    }
    // .page {
    //   // margin-top: 30px;
    //   // float: right;
    //   position: absolute;
    //   bottom: 0px;
    //   left: 0px;
    //   right: 0px;
    //   bottom: 0px;
    //   margin: auto;
    // }
    /* 页码样式结束 */
    .paging_device {
      position: absolute;

      right: 1.04vw;
      bottom: 0.54vw;
    }

    /deep/.el-table--border::after,
    .el-table--group::after {
      width: 0px;
    }
    .tabTit {
      /deep/.el-table__body-wrapper {
        color: red;
        display: none;
        overflow-y: auto;
        height: calc(100% - 180px) !important;
      }
      .el-table__body-wrapper .is-scrolling-none {
        overflow-y: auto;
        height: calc(100% - 180px);
      }
      /deep/.has-gutter {
        tr {
          th {
            border: 0px;
          }
        }
      }
    }

    .tabMain {
      /deep/.has-gutter {
        tr {
          background-color: rgba(224, 237, 252, 1) !important;
          th:nth-child(1) {
            border-left: 1px solid #ebeef5;
          }
          th {
            border-right: 1px solid #ebeef5;
            background-color: rgba(224, 237, 252, 1) !important;
          }
        }
      }
    }
    /deep/.has-gutter {
      tr {
        th {
          border: 0px;
          border-bottom: 1px solid #ebeef5;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
      }
    }
    /deep/.el-table td,
    .el-table th {
      // 修改table行高
      border-right: 1px solid #ebeef5;
      padding: 0px !important;
      height: 45px;
    }
    .el-table th {
      padding: 0px;
    }
    /deep/.el-table td:nth-child(1) {
      border-left: 1px solid #ebeef5;
    }
    /deep/.el-table td {
      text-align: center !important;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(69, 69, 69, 1);
    }
    // /deep/.el-table td:nth-child(3) {
    //   text-align: left;
    // }
    // /deep/.el-table td:nth-child(4) {
    //   text-align: left;
    // }
    /deep/.el-table--enable-row-hover .el-table__body tr tr tr:hover {
      box-shadow: 0px 1px 6px 0px rgba(102, 102, 102, 0.5);
    }
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
      // table 鼠标滑动效果
      background: rgba(210, 210, 210, 1);
    }
    #notDate {
      // 暂无数据
      height: 100%;
      img {
        height: 50%;
        width: 50%;
      }
    }
    /deep/.el-table {
      .el-table__empty-block {
        height: 90% !important;
      }
      border: 0px;
      height: 100%;
      // .el-table__body-wrapper {
      //   color: red;
      //   display: none;
      //   overflow-y: auto;
      //   height: calc(100% - 180px);
      // }
      // height: calc(100% - 129px);
      overflow: auto;
      //   width: 1620px;
      // .ass {
      //   border: 0px;
      //   padding: 5px;
      //   background: transparent;
      // }
      button {
        width: 60px;
        height: 28px;
        line-height: 28px;
        background: rgba(241, 241, 241, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        border-radius: 4px;
        border: 0px;
        color: rgba(153, 153, 153, 1);
      }
      .butClass {
        background: rgba(57, 139, 241, 1);
        color: rgba(255, 255, 255, 1);
        border: 0px;
      }
      .el-table__body-wrapper {
        overflow-y: auto;
        height: calc(100% - 180px) !important;
      }
    }
  }
}
</style>
<style lang="less">
</style>